import React from "react";
import { Typography } from "antd";

export default function InfoCard({ label, children, type }) {
  return (
    <Typography.Paragraph>
      <Typography.Text style={{ marginRight: 10 }} strong>
        {label}
      </Typography.Text>
      <Typography.Text type={type}>{children || "n/a"}</Typography.Text>
    </Typography.Paragraph>
  );
}
